( function( app ) {
  const COMPONENT = {
    init: function() {
      cardContentPositioning();
      $( window ).on( 'resize', function() {
        cardContentPositioning();
      } );
      function cardContentPositioning() {
        if ( window.innerWidth > 768 ) {
          $( '.benefits__card-content' ).each( function() {
            const descriptionHeight = $( this ).outerHeight();
            $( this ).css( 'transform', `translateY(${descriptionHeight}px)` );
          } );
        }
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'benefits', COMPONENT );
} )( app );
